import { timelineGroups } from "./timelineGroups";
import { isLegacyShape, workSections } from "./workSections";

/**
 * Choose how one message renders its work, and prepare the data for it.
 *
 * Two shapes coexist by design. An agent-authored snapshot renders as separate
 * sections; a legacy checkpoint keeps the grouped rendering, because its
 * activity genuinely was attributed to a task and its tasks were created by the
 * planner rather than claimed by the agent.
 */
export function timelineView(workStatus, activity = [], runId = null) {
  if (!isLegacyShape(workStatus)) {
    const sections = workSections(workStatus, activity, runId);
    return {
      sectioned: true,
      sections,
      rows: sections.steps,
      running: sections.steps.find((row) => row.status === "running"),
      isEmpty:
        !sections.plan.length &&
        !sections.confirmed.length &&
        !sections.steps.length,
    };
  }
  const { groups, orphans, trimmed } = timelineGroups(
    workStatus,
    activity,
    runId,
  );
  const rows = [...groups.flatMap((group) => group.rows), ...orphans];
  return {
    sectioned: false,
    rows,
    groups,
    orphans,
    trimmed,
    running: rows.find((row) => row.status === "running"),
    isEmpty: !groups.length && !orphans.length,
  };
}
